import { useLocation, Link } from "react-router-dom";
import { Clock, Sparkles } from "lucide-react";
import { useAuth } from "@/store/AuthContext";

const SHOWN = ["/agenda", "/financeiro", "/medicos", "/diagnostico", "/recepcao", "/atendimento", "/portal"];

export const TrialBanner = () => {
  const { currentUser, subscriptionStatus, daysLeft } = useAuth();
  const location = useLocation();

  if (!SHOWN.includes(location.pathname)) return null;
  if (!currentUser || currentUser === null) return null;
  if (subscriptionStatus !== "trial") return null;

  const urgent = daysLeft != null && daysLeft <= 3;

  return (
    <div
      data-testid="trial-banner"
      className={`fixed left-1/2 top-3 z-40 flex -translate-x-1/2 items-center gap-2.5 rounded-full border px-4 py-2 shadow-[0_8px_30px_rgba(0,0,0,0.12)] backdrop-blur-md ${
        urgent ? "border-rose-200 bg-rose-50/95 text-rose-700" : "border-blue-200 bg-white/95 text-slate-700"
      }`}
    >
      <Clock className={`h-4 w-4 ${urgent ? "text-rose-600" : "text-blue-600"}`} />
      <span className="text-xs font-semibold sm:text-sm">
        Teste grátis · {daysLeft} {daysLeft === 1 ? "dia restante" : "dias restantes"}
      </span>
      <Link
        data-testid="trial-banner-cta"
        to="/assinar"
        className="flex items-center gap-1 rounded-full bg-blue-600 px-3 py-1 text-xs font-bold text-white transition-colors hover:bg-blue-700"
      >
        <Sparkles className="h-3 w-3" /> Assinar
      </Link>
    </div>
  );
};
